import styled from 'styled-components';

export interface FlexInterface {
    justify?: string;
    direction: string;
    wrap?: string;
    align?: string;
    className?: string;
    style?: React.CSSProperties;
    width?: string;
}

export const Flex = styled.div<FlexInterface>`
    display: flex;
    flex-wrap: ${props => props.wrap ? props.wrap : 'no-wrap'};
    flex-direction: ${props => props.direction};
    align-items: ${props => props.align ? props.align : 'center'};
    justify-content: ${props  => props.justify ? props.justify : 'center'};
    className: ${props => props.className};
    width: ${props => props.width};
`;